import { getWorldPoints, pointInPolygon } from "./shapes";
import { resolveConnector } from "./geometry";

// Validate the assembly across levels: off-shape pegs, no material below,
// shapes with zero connectors, and overlapping pegs.
export function inspectAssembly(layers, settings, hasBase) {
  const items = [];
  const present = [...new Set(layers.map((s) => s.level))].sort((a, b) => a - b);
  const idxOf = new Map(present.map((l, i) => [l, i]));
  const byLevel = new Map(present.map((l) => [l, layers.filter((s) => s.level === l)]));

  layers.forEach((shape) => {
    const i = idxOf.get(shape.level);
    const poly = getWorldPoints(shape);
    const hasBelow = i > 0 || hasBase;
    if (hasBelow && (shape.connectors || []).length === 0) {
      items.push({ level: "warn", msg: `${shape.name}: no connectors — won't lock to the layer below`, plateId: shape.id });
    }
    (shape.connectors || []).forEach((cn, k) => {
      const r = resolveConnector(cn, settings);
      const tag = `${shape.name} · snap #${k + 1}`;
      if (!pointInPolygon(cn.x, cn.y, poly)) {
        items.push({ level: "error", msg: `${tag}: peg sits off the shape outline`, plateId: shape.id });
      }
      if (i === 0 && !hasBase) {
        items.push({ level: "warn", msg: `${tag}: nothing below to snap into`, plateId: shape.id });
      } else if (i > 0) {
        const below = byLevel.get(present[i - 1]) || [];
        const covered = below.some((bs) => bs.visible !== false && pointInPolygon(cn.x, cn.y, getWorldPoints(bs)));
        if (!covered) items.push({ level: "warn", msg: `${tag}: hole lands off every shape on the layer below`, plateId: shape.id });
      }
      (shape.connectors || []).forEach((o, m) => {
        if (m <= k) return;
        const d = Math.hypot(o.x - cn.x, o.y - cn.y);
        if (d < r.femaleSize) {
          items.push({ level: "warn", msg: `${tag} & #${m + 1}: pegs ${d.toFixed(2)}mm apart (overlap risk)`, plateId: shape.id });
        }
      });
    });
  });
  return { ok: items.filter((it) => it.level === "error").length === 0, items };
}

export const snapValue = (v, size, enabled) => (enabled && size > 0 ? Math.round(v / size) * size : v);
